import React from 'react';
import { useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import { Container } from 'components/layout/Container';
import Loader from 'components/atoms/Spinner/Loader';
import { Language } from 'language/Language';
import Login from '../../../components/auth/login/Login';
import SignUp from '../../../components/auth/signUp/SignUp';
import './_AuthContainer.scss';

const AuthContainer = () => {
  const language = Language();
  const { isWorking, initializing } = useSelector((state) => state.siteInfo);
  return (
    <>
      <Helmet title={language === 'japan' ? '私のアカウント' : 'My account-login'} />
      <Container>
        {(initializing && isWorking > 0)
          ? (
            <Loader />
          )
          : (
            <div className='auth'>
              <div className='auth-container'>
                <div className='auth-item'>
                  <SignUp />
                </div>
                <div className='auth-item secondary-item'>
                  <Login />
                </div>
              </div>
            </div>
          )}
      </Container>
    </>
  );
};

export default AuthContainer;
